import React from "react";
import PropTypes from "prop-types";

function OutsideLink({ icon, text, route, target = "_blank", overrideStyles = "" }) {
  return (
    <a className={`flex flex-row h-full items-center text-gray-900 text-lg hover:text-gray-700 no-underline py-3 md:py-0 px-2 ${overrideStyles}`} href={route} target={target} rel="noreferrer">
      <span>{icon}</span>
      {text && (
        <span className="text-base text-center my-0 ml-1">{text}</span>
      )}
    </a>
  );
}

OutsideLink.propTypes = {
  icon: PropTypes.object.isRequired,
  route: PropTypes.string.isRequired,
  text: PropTypes.string,
  target: PropTypes.string,
  overrideStyles: PropTypes.string
};

export default OutsideLink;